import React from 'react';

import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper/core';
import { BranchFloorWithMeetingRoom, RetailMenu } from 'store/space/type';

SwiperCore.use([Navigation]);

interface IProps {
  floors?: Array<BranchFloorWithMeetingRoom>;
  menus?: Array<RetailMenu>;
}

const Container = styled.div`
  .mySwiper {
    margin-top: 28px;
    padding: 0 10px 0 10px;
    --swiper-theme-color: black !important;
    --swiper-navigation-size: 25px;

    .menu-img {
      height: 200px;
      width: 100%;
    }

    .menu-info {
      margin-top: 0;
      line-height: 20px;
    }

    .local-slider-div {
    }

    .local-floor-div {
      margin-right: 3vw;
      margin-left: 3vw;
    }

    .detail-img {
      width: 100%;
      min-width: 300px;
      border: 0 none;
    }

    .floor-content {
      margin-top: 0;
      line-height: 20px;

      h4 {
        font-size: 13px;
      }

      p {
        font-size: 13px;
      }
    }
  }

  @media (min-width: 786px) {
    .local-floor-div {
      display: flex;
    }
    .local-slider-div {
      padding: 0 2vw 0 2vw;
      display: flex;
      align-items: center;
    }
    .floor-content {
      padding-left: 28px;
    }
    .menu-info {
      margin-top: 0;
      padding-left: 27px;
      font-size: 15px;
      line-height: 24px;
    }
    .menu-img {
      max-width: 353px;
      width: 45% !important;
    }
  }
`;

const InfoSlider: React.FC<IProps> = ({ floors, menus }: IProps) => {
  return (
    <Container>
      <Swiper navigation spaceBetween={30} loop className="mySwiper">
        {floors &&
          floors.map(floor => (
            <SwiperSlide key={floor.id}>
              <div className="local-floor-div">
                <span className="fl-img" style={{ flex: 1 }}>
                  <img src={floor.image} alt="" className="detail-img" />
                </span>
                <div className="floor-content">
                  <div>
                    <h4>
                      {floor.floor}F {floor.title}
                    </h4>
                    <p>{floor.description}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        {menus &&
          menus.map(menu => (
            <SwiperSlide key={menu.name}>
              <div className="local-slider-div">
                <img src={menu.image} alt="" className="menu-img" />
                <div className="menu-info">
                  <strong>{menu.name}</strong>
                  <p>{menu.description}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </Container>
  );
};

export default InfoSlider;
